import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForSubcontractDetail extends BaseModelAPI {
	static entity = 'pickingsupplyforsubcontractdetail';
	static entityName = 'pickingsupplyforsubcontractdetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingSupplyForSubcontractId = '';
			this.pickingSupplyForSubcontract = {};
			this.workOrderSupplyForSubconDetailId = '';
			this.workOrderSupplyForSubconDetail = {};
			this.partId = '';
			this.part = {};
			this.supplyQty = 0;
			this.remainingQty = 0;
			this.actualQty = 0;
			this.isCompleted = false;
			this.processById = '';
			this.processBy = {};
			this.processDate = '';
			this.remarks = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}